export enum BACKUP_FREQUENCIES {
  DAILY = 'daily',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
  CUSTOM = 'custom',
  INTERVAL_DAYS = 'interval_days',
}

export enum BACKUP_FREQUENCY_UNITS {
  HOURS = 'hours',
  DAYS = 'days',
  MINUTES = 'minutes',
}
